import type React from "react"
import { 
  IconArgentina, 
  IconBolivia, 
  IconBrazil, 
  // IconCanada, 
  IconChile, 
  IconColombia, 
  IconEcuador, 
  IconMexico, 
  IconParaguay, 
  IconPeru, 
  IconUSA, 
  IconUruguay, 
  IconVenezuela,
} from "../assets/icons/icons"
import { dictionary, Language } from "../utils/dictionary"

// ISO 3166-1 ALPHA-2 Country Codes
export enum Country {
  ARGENTINA = "AR",
  BOLIVIA = "BO",
  BRAZIL = "BR",
  CANADA = "CA",
  CHILE = "CL",
  COLOMBIA = "CO",
  ECUADOR = "EC",
  MEXICO = "MX",
  PARAGUAY = "PY",
  PERU = "PE",
  UNITED_STATES = "US",
  URUGUAY = "UY",
  VENEZUELA = "VE",
}

// ISO 4217 Currency Codes
export enum Currency {
  ARS = "ARS", // Argentine Peso
  BOB = "BOB", // Bolivian Boliviano
  BRL = "BRL", // Brazilian Real
  CAD = "CAD", // Canadian Dollar
  CLP = "CLP", // Chilean Peso
  COP = "COP", // Colombian Peso
  USD = "USD", // US Dollar
  MXN = "MXN", // Mexican Peso
  PYG = "PYG", // Paraguayan Guaraní
  PEN = "PEN", // Peruvian Sol
  UYU = "UYU", // Uruguayan Peso
  VES = "VES", // Venezuelan Bolívar
}

export const getCountriesList = (language: Language = Language.SPANISH) => {
  const allowed = [
    "argentina",
    "bolivia",
    "brazil",
    "canada",
    "chile",
    "colombia",
    "ecuador",
    "mexico",
    "paraguay",
    "peru",
    "united-states",
    "uruguay",
    "venezuela",
  ]

  const countryIconsMap: Record<string, React.ComponentType<any> | null> = {
    "argentina": IconArgentina,
    "bolivia": IconBolivia,
    "brazil": IconBrazil,
    "canada": null,
    "chile": IconChile,
    "colombia": IconColombia,
    "ecuador": IconEcuador,
    "mexico": IconMexico,
    "paraguay": IconParaguay,
    "peru": IconPeru,
    "united-states": IconUSA,
    "uruguay": IconUruguay,
    "venezuela": IconVenezuela,
  }

  const allCountries = [
    {
      name: dictionary["argentina"][language],
      flag: "🇦🇷",
      icon: countryIconsMap["argentina"],
      currency: Currency.ARS,
      language: Language.SPANISH,
      country: Country.ARGENTINA,
    },
    {
      name: dictionary["bolivia"][language],
      flag: "🇧🇴",
      icon: countryIconsMap["bolivia"],
      currency: Currency.BOB,
      language: Language.SPANISH,
      country: Country.BOLIVIA,
    },
    {
      name: dictionary["brazil"][language],
      flag: "🇧🇷",
      icon: countryIconsMap["brazil"],
      currency: Currency.BRL,
      language: Language.PORTUGUESE,
      country: Country.BRAZIL,
    },
    {
      name: dictionary["canada"][language],
      flag: "🇨🇦",
      icon: countryIconsMap["canada"],
      currency: Currency.CAD,
      language: Language.ENGLISH,
      country: Country.CANADA,
    },
    {
      name: dictionary["chile"][language],
      flag: "🇨🇱",
      icon: countryIconsMap["chile"],
      currency: Currency.CLP,
      language: Language.SPANISH,
      country: Country.CHILE,
    },
    {
      name: dictionary["colombia"][language],
      flag: "🇨🇴",
      icon: countryIconsMap["colombia"],
      currency: Currency.COP,
      language: Language.SPANISH,
      country: Country.COLOMBIA,
    },
    {
      name: dictionary["ecuador"][language],
      flag: "🇪🇨",
      icon: countryIconsMap["ecuador"],
      currency: Currency.USD,
      language: Language.SPANISH,
      country: Country.ECUADOR,
    },
    {
      name: dictionary["mexico"][language],
      flag: "🇲🇽",
      icon: countryIconsMap["mexico"],
      currency: Currency.MXN,
      language: Language.SPANISH,
      country: Country.MEXICO,
    },
    {
      name: dictionary["paraguay"][language],
      flag: "🇵🇾",
      icon: countryIconsMap["paraguay"],
      currency: Currency.PYG,
      language: Language.SPANISH,
      country: Country.PARAGUAY,
    },
    {
      name: dictionary["peru"][language],
      flag: "🇵🇪",
      icon: countryIconsMap["peru"],
      currency: Currency.PEN,
      language: Language.SPANISH,
      country: Country.PERU,
    },
    {
      name: dictionary["united-states"][language],
      flag: "🇺🇸",
      icon: countryIconsMap["united-states"],
      currency: Currency.USD,
      language: Language.ENGLISH,
      country: Country.UNITED_STATES,
    },
    {
      name: dictionary["uruguay"][language],
      flag: "🇺🇾",
      icon: countryIconsMap["uruguay"],
      currency: Currency.UYU,
      language: Language.SPANISH,
      country: Country.URUGUAY,
    },
    {
      name: dictionary["venezuela"][language],
      flag: "🇻🇪",
      icon: countryIconsMap["venezuela"],
      currency: Currency.VES,
      language: Language.SPANISH,
      country: Country.VENEZUELA,
    },
  ]

  return allCountries
    .filter((c) => allowed.includes(Object.keys(dictionary).find((key) => dictionary[key][language] === c.name) || ""))
    .sort((a, b) => a.name.localeCompare(b.name))
}

export const getLanguagesList = (language: Language = Language.SPANISH) => [
  { name: dictionary["spanish"][language], code: Language.SPANISH },
  { name: dictionary["english"][language], code: Language.ENGLISH },
  { name: dictionary["portuguese"][language], code: Language.PORTUGUESE },
]
